export default __webpack_public_path__ + "static/media/QuestionCSV.dc414603.png";